import {
  FETCH_MASTER_DETAILS,
  FetchDetailsAction,
  FetchDetailsDefaultAction,
  FETCH_MASTER_DETAILS_DEFAULT,
  RESET_MASTER_DETAILS
} from '../../actions/master/fetchMasterDetails';
import { FETCH_MASTER_PAYMENT_PERIODS, FetchMasterPaymentPeriodsAction } from '../../actions/master/fetchMasterPaymentPeriods';
import { FundsType, IPaymentPeriod, Master } from '../../../types/masterTypes';
import { SetChosenFundsTypeAction, SET_CHOSEN_FUNDS_TYPE } from '../../actions/master/setChosenFundsType';

export interface MasterDetailsState {
  master: Master;
  masterDefault: Master;
  paymentPeriods: Array<IPaymentPeriod>;
  chosenFundsType: FundsType;
}

const initialState: MasterDetailsState = {
  master: new Master(),
  masterDefault: new Master(),
  paymentPeriods: [],
  chosenFundsType: FundsType.TotalFunds
};

type FetchMasterDetailsAction = FetchDetailsAction &
  FetchMasterPaymentPeriodsAction &
  FetchDetailsDefaultAction &
  SetChosenFundsTypeAction;

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const masterReducer = (state: MasterDetailsState = initialState, action: FetchMasterDetailsAction): MasterDetailsState => {
  switch (action.type) {
    case FETCH_MASTER_DETAILS:
      return {
        ...state,
        master: action.masterDetails
      };

    case FETCH_MASTER_PAYMENT_PERIODS:
      return {
        ...state,
        paymentPeriods: action.paymentPeriods
      };
    case FETCH_MASTER_DETAILS_DEFAULT:
      return {
        ...state,
        masterDefault: action.masterDetailsDefault
      };
    case RESET_MASTER_DETAILS:
      return {
        master: new Master(),
        masterDefault: new Master(),
        paymentPeriods: [],
        chosenFundsType: FundsType.TotalFunds
      };
    case SET_CHOSEN_FUNDS_TYPE:
      return {
        ...state,
        chosenFundsType: action.chosenFundsType
      };
    default:
      return state;
  }
};

export default masterReducer;
